<section class="page-section">

  <header class="header">
    <h1 translate class="welcome-text">FIRST_STEPS.WEB_CALL.WELCOME</h1>
    <h6 translate class="choose-color-text">FIRST_STEPS.WEB_CALL.COLOR</h6>
  </header>

  <main class="main-wrapper">

    <cc-lg-theme-color class="theme-color" [popupSettings]="popupSettings"></cc-lg-theme-color>
    <cc-lg-text-box class="text-box" [popupSettings]="popupSettings"></cc-lg-text-box>

    <cc-lg-live-preview-bubble></cc-lg-live-preview-bubble>


    <div class="actions-wrapper">
      <button
        mat-button
        mat-raised-button
        color="info-full"
        class="continue"
        (click)="doItLater()"
      >{{'LATER' | translate}}</button>

      <button
        mat-button
        mat-raised-button
        color="primary-full"
        class="continue"
        (click)="continueSteps()"
      >{{'NEXT' | translate}}</button>
    </div>
  </main>
</section>
